import { EventsContent } from './components/EventsContent/EventsContent';
import { EventsHeader } from './components/EventsHeader/EventsHeader';
import { usePixelTesterEvents } from './hooks/usePixelTesterEvents';
import styles from './eventsWrapper.module.scss';

export const EventsWrapper = ({ isOnBoarding }) => {
    const { pixelTesterEvents, eventsIssuesCount, eventsWorstIssueType } = usePixelTesterEvents();

    return (
        <div className={styles['container']}>
            <EventsHeader issueCount={eventsIssuesCount} worstIssueType={eventsWorstIssueType} />
            <EventsContent pixelTesterEvents={pixelTesterEvents} isOnBoarding={isOnBoarding} />
        </div>
    );
};
